module.exports = __webpack_public_path__ + "static/img/lifestyle_25.0d747717.jpg";